import { lazyWithRetry } from '@/utils/lazyWithRetry';

export const Login = lazyWithRetry(() =>
  import('@/features/auth/pages/Login').then(m => ({ default: m.Login }))
);

export const Signup = lazyWithRetry(() =>
  import('@/features/auth/pages/Signup').then(m => ({ default: m.Signup }))
);

export const ForgotPassword = lazyWithRetry(() =>
  import('@/features/auth/pages/ForgotPassword').then(m => ({ default: m.ForgotPassword }))
);

export const VerifyEmail = lazyWithRetry(() =>
  import('@/features/auth/pages/VerifyEmail').then(m => ({ default: m.VerifyEmail }))
);

export const ResetPassword = lazyWithRetry(() =>
  import('@/features/auth/pages/ResetPassword').then(m => ({ default: m.ResetPassword }))
);

export const OAuthCallback = lazyWithRetry(() =>
  import('@/features/auth/pages/OAuthCallback').then(m => ({ default: m.OAuthCallback }))
);

export const OnboardingFlow = lazyWithRetry(() =>
  import('@/features/onboarding/pages/OnboardingFlow').then(m => ({ default: m.OnboardingFlow }))
);

export const AutomationPage = lazyWithRetry(() =>
  import('@/features/onboarding/pages/AutomationPage').then(m => ({ default: m.AutomationPage }))
);
